<template>
  <Teleport to="body">
    <div
      v-if="showBanner"
      class="fixed inset-x-0 bottom-0 z-40 p-3 sm:p-4 pointer-events-none"
      role="dialog"
      aria-labelledby="pwa-install-title"
    >
      <div class="pointer-events-auto mx-auto w-full max-w-xl rounded-xl border border-default bg-default shadow-2xl px-4 py-3 sm:px-5 sm:py-3.5">
        <div class="flex items-start gap-3">
          <div class="mt-0.5 rounded-lg bg-brand-50 p-2 text-brand-600">
            <UIcon name="i-heroicons-device-phone-mobile" class="size-5" />
          </div>
          <div class="min-w-0 flex-1">
            <h2 id="pwa-install-title" class="text-sm font-semibold text-highlighted">
              Adaugă {{ site.name }} pe ecranul principal
            </h2>
            <p v-if="isIos && isIosChrome" class="mt-1 text-xs text-muted">
              Deschide site-ul în Safari, apoi Share → Add to Home Screen. Notificările funcționează doar din aplicația de pe ecran.
            </p>
            <p v-else-if="isIos" class="mt-1 text-xs text-muted">
              Apasă Share
              <UIcon name="i-heroicons-arrow-up-on-square" class="inline-block size-3.5 align-text-bottom" />
              apoi „Add to Home Screen”. După instalare poți primi notificări la comenzi noi.
            </p>
            <p v-else class="mt-1 text-xs text-muted">
              Instalează panoul ca aplicație ca să primești notificări la comenzi noi.
            </p>
            <div class="mt-3 flex flex-wrap items-center gap-2">
              <UButton
                v-if="canPromptInstall"
                label="Instalează"
                size="sm"
                color="primary"
                @click="() => { void promptInstall() }"
              />
              <UButton
                label="Mai târziu"
                size="sm"
                color="neutral"
                variant="ghost"
                @click="dismiss"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const { site } = useSiteSettings()
const {
  showBanner,
  isIos,
  isIosChrome,
  canPromptInstall,
  dismiss,
  promptInstall,
} = usePwa()
</script>
